module.exports = __webpack_public_path__ + "static/media/near_capacity_normal.2a4a856e.svg";